import './BackgroundCard.css';

/**
 * BackgroundCard Component
 * Displays a single page background with image preview and edit action
 *
 * Props:
 * - background: PageBackground object from backend API
 * - onEdit: (background) => void - Opens edit modal
 * - isUpdating: boolean - Disable actions while updating
 */
function BackgroundCard({ background, onEdit, isUpdating = false }) {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  };

  const getPageLabel = (page) => {
    return page === 'home' ? 'Home Page' : 'Product Listing';
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    if (!isUpdating) {
      onEdit(background);
    }
  };

  const isHomePage = background.page === 'home';
  const hasBannerContent = isHomePage && (background.title || background.subtitle || background.buttonText);

  return (
    <div className="background-card">
      <div className="background-card__header">
        <h3 className="background-card__title">{getPageLabel(background.page)}</h3>
        <span className="background-card__badge">Active</span>
      </div>

      <div
        className="background-card__image"
        style={{ backgroundImage: `url(${background.imageUrl})` }}
      >
        {/* Banner overlay for Home Page */}
        {hasBannerContent && (
          <div className="background-card__banner-overlay">
            {background.title && (
              <h4 className="background-card__banner-title">{background.title}</h4>
            )}
            {background.subtitle && (
              <p className="background-card__banner-subtitle">{background.subtitle}</p>
            )}
            {background.buttonText && (
              <span className={`background-card__banner-button background-card__banner-button--${background.buttonStyle || 'white-trans-btn-with-white-border'}`}>
                {background.buttonText}
              </span>
            )}
            {background.readMoreContent && (
              <span className="background-card__banner-readmore-indicator">
                + Read More Content
              </span>
            )}
          </div>
        )}

        {/* Page hint overlay (only show when no banner content) */}
        {!hasBannerContent && (
          <div className="background-card__image-overlay">
            <span className="background-card__page-hint">/{background.page === 'home' ? '' : 'product-listing'}</span>
          </div>
        )}
      </div>

      <div className="background-card__footer">
        <div className="background-card__meta">
          <span className="background-card__updated">
            Updated: {formatDate(background.updatedAt)}
          </span>
          {background.description && (
            <span className="background-card__description" title={background.description}>
              {background.description}
            </span>
          )}
        </div>

        <button
          type="button"
          className="btn btn-primary"
          onClick={handleEdit}
          disabled={isUpdating}
        >
          {isUpdating ? (
            <>
              <span className="btn-spinner" />
              Saving...
            </>
          ) : (
            'Edit'
          )}
        </button>
      </div>
    </div>
  );
}

export default BackgroundCard;
